import { create } from 'zustand';

type ModalType =
  | 'crop'
  | 'banner'
  | 'bannerCrop'
  | 'bannerSearch'
  | 'memeSearch'
  | 'memeTextEdit'
  | 'memeSettings'
  | null;

interface UIState {
  activeModal: ModalType;
  openModal: (modal: ModalType) => void;
  closeModal: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  activeModal: null,

  openModal: (modal: ModalType) => {
    set({ activeModal: modal });
  },

  closeModal: () => {
    set({ activeModal: null });
  },
}));
